import type { ParseKeys } from 'i18next';
import type { SortableGuidelineKeys } from './GuidelinesDatatable.types';

interface ColumnConfig {
  key: SortableGuidelineKeys;
  labelKey: ParseKeys<'knowledge'>;
  /**
   * A literal Tailwind class, not an interpolated one: Tailwind v4 scans
   * source text for class names, so `` `w-[${width}]` `` never gets
   * generated and the column silently loses its pinned width.
   */
  className: string;
}

/**
 * Drives both the header row and the body cells from one source, so the two
 * cannot drift out of order. `category` renders through `CategoryFilterHead`
 * instead of the shared `SortableHead`, which pins its own width directly;
 * every other key uses `SortableHead` with the `className` below.
 */
export const GUIDELINES_COLUMNS: readonly ColumnConfig[] = [
  { key: 'name', labelKey: 'guidelines.guidelinesTable.name', className: 'w-[21%]' },
  { key: 'description', labelKey: 'guidelines.guidelinesTable.description', className: 'w-[42%]' },
  { key: 'category', labelKey: 'guidelines.guidelinesTable.category', className: 'w-[15%]' },
  { key: 'created', labelKey: 'guidelines.guidelinesTable.addedAt', className: 'w-[21%]' },
];
